// extracted by mini-css-extract-plugin
export default {"table":"ViewProduct_table__fG4n-","search":"ViewProduct_search__EKmTC","icons":"ViewProduct_icons__CKslT"};